import * as React from 'react';
import {View} from 'react-native';
import {images} from '../../../../../assets/icons';
import {useStyles} from '../../../../hooks/styles';
import {useOnClickOutside} from '../../../../hooks/useOutsideClick';
import {Button} from '../../../button';
import {RisingView} from '../../../risingView';
import {CustomScrollView} from '../../../scrollView';
import {AcceptorsFilterList} from '../../components/list';
import {AcceptorsFilterViewBaseProps} from '../../model';

export const AcceptorsFilterDesktop: React.FC<AcceptorsFilterViewBaseProps> = ({acceptorCategories, onSubmit}) => {
  const [isActive, setActive] = React.useState<boolean>(false);
  const wrapRef = React.useRef<any | null>(null);

  useOnClickOutside(wrapRef, () => {
    setActive(false);
  });

  const styles = useStyles(({theme, addShadow}) => ({
    wrapper: {
      position: 'relative',
      zIndex: 0,
    },
    activateButton: {
      width: 160,
    },
    filterPanel: {
      position: 'absolute',
      right: 0,
      zIndex: 100,
      top: 60,
      width: 300,
      backgroundColor: theme.color.primaryNonGreyBackground,
      paddingTop: 0,
      ...addShadow({
        height: 8,
        radius: 25,
        opacity: 0.1,
      }),
      borderRadius: 5,
    },
    filterScrollContainer: {
      maxHeight: 330,
    },
    filterScrollContentContainer: {
      paddingVertical: 20,
      paddingLeft: 20,
    },
    filterButtonContainer: {
      paddingVertical: 12,
      paddingHorizontal: 20,
      alignItems: 'center',
      borderTopWidth: 1,
      borderStyle: 'solid',
      borderTopColor: theme.color.borderColor,
    },
    filterButton: {
      width: 200,
    },
  }));

  return (
    <View
      ref={(ref) => {
        wrapRef.current = ref;
      }}
      style={styles.wrapper}>
      <Button
        id='filter-category'
        style={styles.activateButton}
        onPress={() => setActive(!isActive)}
        text='Категория'
        type={isActive ? 'primary' : 'secondary'}
        iconPosition='right'
        icon={isActive ? images.ArrowUp : images.ArrowDown}
        iconProps={{width: 20, height: 20}}
      />
      <RisingView style={styles.filterPanel} isActive={isActive}>
        <CustomScrollView
          contentContainerStyle={styles.filterScrollContentContainer}
          style={styles.filterScrollContainer}
          {...{dataSet: {class: 'custom-scroll'}}}>
          <AcceptorsFilterList acceptorCategories={acceptorCategories} />
        </CustomScrollView>
        <View style={[styles.filterButtonContainer]}>
          <Button
            id='filter-show'
            text='Показать'
            type='secondary'
            style={styles.filterButton}
            onPress={() => {
              onSubmit();
              setActive(false);
            }}
          />
        </View>
      </RisingView>
    </View>
  );
};
